import { dialog } from "nq-component";
import BaseListPresenter from "../../../../../base/BaseListPresenter";
import DialogModal from "../../../../../components/Dialog";
import { auditLogUseCase } from "../../../../../usecases/logs";

class RawMaterialPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase
  ) {
    super(view, findObjectUseCase, deleteObjectUseCase);
    this.findObjectUseCase = findObjectUseCase;
    this.countObjectUseCase = countObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  init() {
    const user = this.view.getCurrentUser();
    // const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    // const storeId = user?.storeAnalytic?.[0]?.id;
    // this.where = hasAdminRole ? {} : { "storeId.id": { $eq: storeId } };
    this.where = {};
    this.limit = 20;
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.reset();
    await this.countObjects();
    await this.findObjects();
  }

  async countObjects() {
    try {
      this.showProgress();
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: query.where,
      });
      this.count = count;
      this.view.setCount(this.count);
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setObjects(this.objects);
      this.view.setCount(this.count);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  onClickAdd() {
    this.view.navigateTo("/collection/raw_material/form");
  }

  onClickEdit(index) {
    const object = this.objects[index];
    this.view.navigateTo("/collection/raw_material/form/" + object.id);
  }

  async onClickDelete(index) {
    dialog.close();
    const user = this.view.getCurrentUser();
    const object = this.objects[index];
    const collection = this.view.getCollectionName();

    await auditLogUseCase().delete({
      user,
      logDate: new Date().toISOString(),
      message: `Deleted Raw Material: ${object.itemName} `,
      collection,
      objectId: object.id,
      payload: object,
    });
    await this.deleteObjectUseCase.execute(collection, object.id);

    // const indexes = this.objects.indexOf(object.id);
    // this.objects.splice(indexes, 1);
    // this.view.setObjects(this.objects);
    // remove exactly the clicked row
    this.objects.splice(index, 1);
    this.view.setObjects([...this.objects]); // spread to trigger updates if needed

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Deleted Successfully"
          message=""
          isCancelButton={false}
          onSubmit={() => {
            dialog.close();
          }}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }
  onClickImport() {}
  onClickExport() {}
}

export default RawMaterialPresenter;
